import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="border-t bg-white">
      <div className="mx-auto max-w-6xl px-4 py-10">
        <div className="grid gap-6 md:grid-cols-3">
          <div>
            <div className="text-lg font-semibold">OjoVest</div>
            <p className="mt-2 text-sm text-slate-600">
              Premium loan and credit card assistance for India & NRI clients.
            </p>
            <p className="mt-3 text-xs text-slate-500">
              Disclaimer: OjoVest provides assistance and advisory support. Final approval,
              interest rate, fees and terms depend on the respective lender/issuer policies.
            </p>
          </div>

          <div>
            <div className="text-sm font-semibold">Legal</div>
            <div className="mt-3 flex flex-col gap-2 text-sm text-slate-700">
              <Link to="/privacy" className="hover:underline">Privacy Policy</Link>
              <Link to="/terms" className="hover:underline">Terms of Use</Link>
              <Link to="/refund" className="hover:underline">Refund Policy</Link>
            </div>
          </div>

          <div>
            <div className="text-sm font-semibold">Contact</div>
            <div className="mt-3 flex flex-col gap-2 text-sm text-slate-700">
              <Link to="/contact" className="hover:underline">Contact Page</Link>
              <a href="mailto:support@ojovest.com" className="hover:underline">
                support@ojovest.com
              </a>
              <a href="tel:+919999999999" className="hover:underline">
                +91 99999 99999
              </a>
            </div>
          </div>
        </div>

        <div className="mt-8 text-xs text-slate-500">
          © {year} OjoVest. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
